import { render, staticRenderFns } from "./CategoryFilter.vue?vue&type=template&id=8130ef24&scoped=true&"
import script from "./CategoryFilter.vue?vue&type=script&lang=ts&"
export * from "./CategoryFilter.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryFilter.vue?vue&type=style&index=0&id=8130ef24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8130ef24",
  null
  
)

export default component.exports